// src/hooks/useBloqueos.js
// Bloqueos de agenda (vacaciones, festivos, formación…) del día que se ve en la Agenda.
import { useState, useEffect, useCallback, useRef } from 'react';
import api from '../services/api';
import { useToast } from '../context/ToastContext';

export const MOTIVOS_BLOQUEO = [
    { id: 'vacaciones', label: 'Vacaciones' },
    { id: 'festivo', label: 'Festivo' },
    { id: 'formacion', label: 'Formación' },
    { id: 'otro', label: 'Otro' }
];

export const etiquetaMotivoBloqueo = (bloqueo) => {
    const base = MOTIVOS_BLOQUEO.find(m => m.id === bloqueo?.motivo)?.label || 'Bloqueado';
    return bloqueo?.nota ? `${base}: ${bloqueo.nota}` : base;
};

export function useBloqueos(fecha) {
    const { showToast } = useToast();
    // showToast cambia en cada aviso: con un ref, un error de carga no provoca otra carga
    const toastRef = useRef(showToast);
    toastRef.current = showToast;
    const [bloqueos, setBloqueos] = useState([]);

    const cargarBloqueos = useCallback(async () => {
        const desde = new Date(fecha); desde.setHours(0, 0, 0, 0);
        const hasta = new Date(desde); hasta.setDate(hasta.getDate() + 1);
        try {
            const res = await api.get(`/bloqueos?desde=${desde.toISOString()}&hasta=${hasta.toISOString()}`);
            setBloqueos(Array.isArray(res) ? res : []);
        } catch (err) {
            console.error('Error cargando bloqueos:', err);
            toastRef.current('No se pudieron cargar los bloqueos de agenda', 'error');
        }
    }, [fecha]);

    useEffect(() => { cargarBloqueos(); }, [cargarBloqueos]);

    // Bloqueo que cubre el tramo [hora, hora + 30 min) del día para ese profesional
    const obtenerBloqueo = useCallback((hora, medicoId) => {
        const [h, m] = hora.split(':').map(Number);
        const inicioSlot = new Date(fecha); inicioSlot.setHours(h, m, 0, 0);
        const finSlot = new Date(inicioSlot.getTime() + 30 * 60 * 1000);
        return bloqueos.find(b =>
            (b.profesional === null || String(b.profesional) === String(medicoId)) &&
            new Date(b.inicio) < finSlot && new Date(b.fin) > inicioSlot
        ) || null;
    }, [bloqueos, fecha]);

    return { bloqueos, cargarBloqueos, obtenerBloqueo };
}
